import Vue from "vue";
import VueI18n from "vue-i18n";

import pt_BR from "./locales/pt_BR";
import pt_PT from "./locales/pt_PT";
import en from "./locales/en";
import es from "./locales/es";

Vue.use(VueI18n);

const messages = {
  pt_BR,
  pt_PT,
  en,
  es
};

const savedLocale =
  localStorage.getItem("locale") || navigator.language.replace("-", "_");

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: {
    default: ["en", "pt_BR"]
  },
  messages
});

export default i18n;
